<template>
  <div class="pass-input-wrapper" :class="error[0] ? 'is-invalid' : ''">
    <label v-if="name" class="input-label" :for="id">
      {{ configuredName }}
      <NbHelpText
        v-if="helpText"
        :id="`${id}-popover`"
        class="mx-1"
        :size="helpTextSize"
        placement="topright"
      >
        {{ helpText }}
      </NbHelpText>
    </label>
    <!-- :type="hiddePassword ? 'password' : 'text'" -->
    <input
      class="form-control input"
      :id="id"
      :placeholder="placeholder"
      aria-autocomplete="none"
      :autocomplete="autocomplete"
      v-model="textContent"
      :class="computedClasses"
    />
    <span class="pass-icon" @click="switchTypeInput()">
      <NbIcon
        :icon="hiddePassword ? 'eye' : 'eye-off'"
        :attributes="{
          width: '1rem',
          height: '1rem',
        }"
      />
    </span>
    <ErrorFeedback :error="error[0]" />
  </div>
</template>

<script>
import ErrorFeedback from "../../generic/ErrorFeedback.vue";
import NbHelpText from "@/components/generic/NbHelpText.vue";
import NbIcon from "@/components/icons/NbIcon.vue";

export default {
  name: "nbBaseInput",
  components: {
    ErrorFeedback,
    NbHelpText,
    NbIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    helpText: {
      type: String,
      required: false,
    },
    helpTextSize: {
      type: String,
      default: "sm",
    },
    prepend: {
      type: String,
      required: false,
    },
    append: {
      type: String,
      required: false,
    },
    autocomplete: {
      type: String,
      required: false,
    },
    error: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      textContent: this.value,
      hiddePassword: true,
    };
  },
  methods: {
    switchTypeInput() {
      this.hiddePassword = !this.hiddePassword;
    },
  },
  computed: {
    configuredName() {
      if (this.required) {
        return `${this.name} *`;
      }
      return this.name;
    },
    computedClasses() {
      let classes = "";
      if (this.error[0]) {
        classes += " is-invalid";
      }
      if (this.textContent && this.textContent.length > 0) {
        classes += this.hiddePassword ? " password" : " text";
      } else {
        classes += " text";
      }

      return classes;
    },
  },
  watch: {
    //altera o input
    textContent(newValue) {
      this.$emit("input", newValue);
    },
    //altera o modal do pai
    value(newValue) {
      this.textContent = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.pass-input-wrapper {
  position: relative;
}
.pass-input-wrapper > .pass-icon {
  position: absolute;
  top: 2.375rem;
  right: 1rem;
  color: var(--gray-60);
  cursor: pointer;
}

.pass-input-wrapper > .form-control.password {
  font: normal normal 600 14px/20px var(--font-family-pass);
}

//inputs
.input-label {
  color: var(--black);
  text-align: left;
  font: normal normal 600 12px/16px var(--font-family-base);
  letter-spacing: 0px;
  display: inline-block;
  margin-bottom: 0.5rem;
  cursor: default;
}
.form-control.input:not(:placeholder-shown),
.form-control.input.is-invalid:not(:placeholder-shown) {
  border-bottom: 2px solid var(--black);
}
.form-control.input {
  transition: all 0.3s ease;
  height: 2.5rem;
  //height: calc(2em + 0.75rem + 2px);
  /* 
  border-radius: 4px;
  font: $text16_20;
  */
  padding: 9px 12px;
  box-shadow: none;
  border: none;
  border-bottom: 2px solid var(--gray-40);
  font: normal normal normal 14px/20px var(--font-family-base);
  background: var(--gray-05) 0% 0% no-repeat padding-box !important;
  border-radius: 4px 4px 0px 0px;
}
.form-control.input:hover {
  //color: var(--gray-40);
  background: var(--gray-10) 0% 0% no-repeat padding-box !important;
}
.form-control.input:focus {
  box-shadow: none;
  border-bottom: 2px solid var(--black);
}
.form-control.input::placeholder {
  color: var(--gray-40);
}

.form-control.input.is-valid {
  border-bottom: 2px solid var(--success);
  caret-color: var(--success);
  background-image: none;
}
.form-control.input.is-invalid {
  border-bottom: 2px solid var(--error);
  caret-color: var(--error);
  background-image: none;
}
.form-control.input.is-invalid:hover {
  background: var(--gray-10) 0% 0% no-repeat padding-box;
}
.form-control.input:disabled,
.form-control.input[disabled] {
  background-color: var(--gray-05) !important;
  color: var(--gray-20) !important;
  border-bottom: 2px solid var(--gray-20);
}
</style>
